export default "__VITE_ASSET__c7714cd3__"